import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getCoordinatorGroupMembers } from 'AppSrc/core/coordinators/coordinator-queries';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import { groupMemberShape } from 'AppSrc/core/data-structures/api-proptypes';
import { connect } from 'react-redux';
import './select-coordinator-table.css';

const SelectCoordinatorTableDisplay = ({
  groupMembers,
  coordinatorId,
  setCoordinator,
  isEmergency,
  isOlo,
}) => {
  const numResults = groupMembers.length;
  const [displayName, setDisplayName] = useState(groupMembers);
  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    setDisplayName(displayName);
  }, [displayName]);
  const searchHandler = (event) => {
    // Search function for filter array by searching any related text keywords
    const searchQuery = event.toLowerCase();
    const displayedName = groupMembers.filter((el) => {
      const searchValue = el.full_name.toLowerCase().includes(searchQuery);
      return searchValue;
    });

    setDisplayName(displayedName);
    setSearchInput(event);
  };
  if (!numResults) {
    return (
      <h4 className="select-coordinator-table-title">
        Group has no members, please select another group
      </h4>
    );
  }
  // Sort Peer Approver group in alphabetical order
  displayName.sort((a, b) => a.full_name.localeCompare(b.full_name));
  return (
    <React.Fragment>
      <h4 className="select-coordinator-table-title">{`Group members (${numResults})`}</h4>
      <div className="select-coordinator-table vf-table">
        <div className="vf-table-head-container">
          <div className="vf-table-head">
            <div className="head-item">
              <span className="head-text">
                Name
              </span>
            </div>
            <div className="head-item">
              <span className="head-text">
                ID
              </span>
            </div>
          </div>
        </div>
        <>
          { // Search div when default array length > 2
            groupMembers.length > 2 && (
              <div className="search-drop">
                <input
                  className="Search-Input"
                  type="text"
                  onChange={(e) => searchHandler(e.target.value)}
                  placeholder=" Please Search Here..."
                  value={searchInput}
                />
                <div className={`no-result-msg ${displayName.length === 0 ? 'show-no-result' : 'hide-no-result'}`}><p>No Search Result Found</p></div>
              </div>
            )
          }
        </>
        <div className="vf-table-body">
          {
            displayName.map((member) => {
              const isSelected = member.id === coordinatorId;
              return (
                <div
                  className={`vf-table-row-container${isSelected ? ' selected' : ''}`}
                  key={member.id}
                >
                  <div className="vf-table-row">
                    <OptionButton
                      className="row-button"
                      onClick={setCoordinator}
                      option={member}
                      disabled={isSelected}
                    >
                      <div className="row-item">
                        <span className="row-item-text">
                          {member.full_name}
                        </span>
                      </div>
                      <div className="row-item">
                        <span className="row-item-text">
                          {member.id}
                        </span>
                      </div>
                    </OptionButton>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    </React.Fragment>
  );
};

SelectCoordinatorTableDisplay.propTypes = {
  groupMembers: PropTypes.arrayOf(groupMemberShape),
  coordinatorId: PropTypes.string,
  setCoordinator: PropTypes.func,
  isEmergency: PropTypes.bool,
  isOlo: PropTypes.bool,
};
let apiCallCount = 0;
class SelectCoordinatorTableUnconnected extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groupMembers: [],
      fetching: false,
      // apiCallCount: 0,
    };
  }

  componentDidMount() {
    const
      {
        network,
        groupId,
        isEmergency,
        isOlo,
      } = this.props;
    let groupIdsession;
    if (network === 'fixed') {
      if (!window.sessionStorage.getItem('emergencygroupIdfixed')) {
        window.sessionStorage.setItem('emergencygroupIdfixed', groupId);
      }
      groupIdsession = window.sessionStorage.getItem('emergencygroupIdfixed');
    }
    if (network === 'mobile') {
      if (!window.sessionStorage.getItem('emergencygroupIdmobile')) {
        window.sessionStorage.setItem('emergencygroupIdmobile', groupId);
      }
      groupIdsession = window.sessionStorage.getItem('emergencygroupIdmobile');
    }
    this.setState({ fetching: true }, () => {
      apiCallCount += 1;
      console.log('API call count:', apiCallCount);

      if (groupId === groupIdsession && isEmergency && !isOlo) {
        this.setState({
          groupMembers: [],
          fetching: false,
        });
      }
      else {
        getCoordinatorGroupMembers(network, groupId).then((groupMembers) => {
          this.setState({
            groupMembers,
            fetching: false,
          });
        }).catch((error) => {
          console.error(error);
          this.setState({ fetching: false });
        });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.groupMembers !== this.state.groupMembers) {
      console.log('Group members updated:', this.state.groupMembers);
    }
  }

  render() {
    const { fetching, groupMembers } = this.state;
    const {
      setCoordinator,
      coordinatorId,
      coordinatorIdToExclude,
      isEmergency,
      isOlo,
    } = this.props;
    if (fetching) {
      return <p>Loading...</p>;
    }
    // filter out the coordiatorIdToExclude
    const filteredMembers = groupMembers.filter((member) => coordinatorIdToExclude !== member.id);
    // const isEmergency = true;
    // filteredMembers = (this.props.groupId === 'SGP000000000013') && isEmergency ? [] : filteredMembers : [];
    return (
      <SelectCoordinatorTableDisplay
        groupMembers={filteredMembers}
        coordinatorId={coordinatorId}
        setCoordinator={setCoordinator}
        isEmergency={isEmergency}
        isOlo={isOlo}
      />
    );
  }
}

SelectCoordinatorTableUnconnected.propTypes = {
  network: PropTypes.string,
  groupId: PropTypes.string,
  coordinatorId: PropTypes.string,
  setCoordinator: PropTypes.func,
  coordinatorIdToExclude: PropTypes.string,
  isEmergency: PropTypes.bool,
  isOlo: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const { network } = ownProps;
  const { remedyIds } = state.auth.user;
  const loggedInCoordinatorId = remedyIds[network];
  const coordinatorIdToExclude = ownProps.excludeLoggedInCoordinator ? loggedInCoordinatorId : null;
  return ({
    coordinatorIdToExclude,
  });
};

const SelectCoordinatorTable = connect(
  mapStateToProps,
)(SelectCoordinatorTableUnconnected);

export {
  SelectCoordinatorTable,
  SelectCoordinatorTableUnconnected,
  SelectCoordinatorTableDisplay,
};

